export default "__VITE_ASSET__NgNGz3p1__"